import { useEffect, useState } from "react";
import { Volume2, VolumeX, Volume1 } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Slider } from "@/components/ui/slider";
import { Switch } from "@/components/ui/switch";
import { getPrefs, setPrefs, subscribePrefs, sfx } from "@/lib/sounds";

export default function SoundSettings() {
  const [prefs, setLocal] = useState(getPrefs());
  useEffect(() => subscribePrefs(setLocal), []);
  const Icon = !prefs.enabled ? VolumeX : prefs.volume > 0.5 ? Volume2 : Volume1;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          data-testid="sound-settings-toggle"
          onClick={() => sfx.click()}
          className="p-2 rounded-full hover:bg-white/5 border border-transparent hover:border-white/10 text-white/80"
          aria-label="Sound settings"
        >
          <Icon size={18} />
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-72 bg-black/90 border border-white/10 text-white backdrop-blur-xl">
        <div className="text-[11px] uppercase tracking-[0.3em] text-[#FFBF00] mb-3">Sound</div>
        <div className="flex items-center justify-between mb-4">
          <div className="text-sm">Enable sounds</div>
          <Switch
            data-testid="sound-enabled-switch"
            checked={prefs.enabled}
            onCheckedChange={(v) => { setPrefs({ enabled: v }); if (v) sfx.pling(); }}
          />
        </div>
        <div className="text-sm mb-2 flex items-center justify-between">
          <span>Volume</span>
          <span className="font-mono text-[#FFBF00]">{Math.round(prefs.volume * 100)}%</span>
        </div>
        <Slider
          data-testid="sound-volume-slider"
          value={[Math.round(prefs.volume * 100)]}
          min={0}
          max={100}
          step={5}
          onValueChange={([v]) => setPrefs({ volume: v / 100 })}
          onValueCommit={() => sfx.click()}
        />
        <div className="mt-4 grid grid-cols-3 gap-1.5">
          {[
            ["Click", "click"], ["Pling", "pling"], ["Level Up", "levelup"],
            ["No", "no"], ["Copy", "copy"], ["Menu", "menu"],
          ].map(([label, key]) => (
            <button
              key={key}
              data-testid={`sound-test-${key}`}
              onClick={() => sfx[key]?.()}
              className="text-[10px] uppercase tracking-widest px-2 py-1.5 rounded-md border border-white/10 hover:border-[#FFBF00]/50 hover:bg-white/5"
            >
              {label}
            </button>
          ))}
        </div>
        <div className="text-[10px] text-white/40 mt-3 leading-relaxed">
          Sounds are generated locally — no assets loaded. Your preference is saved on this device.
        </div>
      </PopoverContent>
    </Popover>
  );
}
